import { render } from "./NcrmEmailMarketingCampaignsTab.vue?vue&type=template&id=4e39073a&scoped=true"
import script from "./NcrmEmailMarketingCampaignsTab.vue?vue&type=script&lang=js"
export * from "./NcrmEmailMarketingCampaignsTab.vue?vue&type=script&lang=js"

import "./NcrmEmailMarketingCampaignsTab.vue?vue&type=style&index=0&id=4e39073a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e39073a"]])

export default __exports__